import { render, staticRenderFns } from "./homeSearch.vue?vue&type=template&id=ccdb8f46&"
import script from "./homeSearch.vue?vue&type=script&lang=js&"
export * from "./homeSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/home/menu/college/homeSearch.vue"
export default component.exports